import { render } from "./NSelectTags.vue?vue&type=template&id=00993f9f&ts=true"
import script from "./NSelectTags.vue?vue&type=script&lang=ts"
export * from "./NSelectTags.vue?vue&type=script&lang=ts"

import "./NSelectTags.vue?vue&type=style&index=0&id=00993f9f&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__